// extracted by mini-css-extract-plugin
export default {"saveBtnWrapper":"RistopubAddressInput_saveBtnWrapper__9WMZR"};